import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Paper,
    Divider,
    Chip,
    Checkbox,
    FormGroup,
    FormControlLabel,
    IconButton,
    InputAdornment,
    Badge,
    Tooltip,
    Avatar,
    Card, Stack, Alert,
    CardContent,
    LinearProgress,
    alpha
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SaveIcon from '@mui/icons-material/Save';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import BakeryDiningIcon from '@mui/icons-material/BakeryDining';
import TodayIcon from '@mui/icons-material/Today';
import PrintIcon from '@mui/icons-material/Print';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EventIcon from '@mui/icons-material/Event';
import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../lib/axios';
import { selectGlobalProperty } from '../../redux/propertySlice';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import Datepopup from './Datepopup';
import AddIcon from '@mui/icons-material/Add';
import PrintDialog from './PrintDialog';
import { usePermissions } from '../../GlobalFunction/userPermissions';

const StyledPaper = styled(Paper)(({ theme }) => ({
    transition: 'none',
}));

const GradientHeader = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: theme.spacing(1),
    color: 'white',
}));

const MealIcon = ({ type }) => {
    const icons = {
        breakfast: <BakeryDiningIcon />,
        lunch: <LunchDiningIcon />,
        snack: <FastfoodIcon />,
        dinner: <DinnerDiningIcon />
    };
    return icons[type] || <RestaurantMenuIcon />;
};

const DaywiseFood = () => {
    const [selectedDay, setSelectedDay] = useState(() => {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days[new Date().getDay()];
    });
    const [selectedMeal, setSelectedMeal] = useState('');
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
    const [searchText, setSearchText] = useState('');
    const [checkedItems, setCheckedItems] = useState({});
    const [showSuccess, setShowSuccess] = useState(false);
    const [categoryStats, setCategoryStats] = useState({});
    const [mealType, setMealType] = useState([]);
    const [foodItems, setFoodItems] = useState({});
    const [loading, setLoading] = useState(false);
    const [savedMenus, setSavedMenus] = useState({});
    const globalProperty = useSelector(selectGlobalProperty);
    const UserId = sessionStorage.getItem("UserId");
    const [hasChanges, setHasChanges] = useState(false);
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [open, setOpen] = useState(false);
    const [printDialogOpen, setPrintDialogOpen] = useState(false);
    const permissions = usePermissions("Day Wise Food");
      console.log("Permissions for Day Wise Food:", permissions);
    const months = [
        { value: 1, name: 'January' },
        { value: 2, name: 'February' },
        { value: 3, name: 'March' },
        { value: 4, name: 'April' },
        { value: 5, name: 'May' },
        { value: 6, name: 'June' },
        { value: 7, name: 'July' },
        { value: 8, name: 'August' },
        { value: 9, name: 'September' },
        { value: 10, name: 'October' },
        { value: 11, name: 'November' },
        { value: 12, name: 'December' }
    ];

    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    const handlePrintClick = () => {
        setPrintDialogOpen(true);
    };

    const fetchMealTypesForDropdown = async () => {
        try {
            const response = await axiosInstance.post('MstFood/GetdrpMstMealType', {
                Flag: '',
            });
            if (response.data.Status === 0) {
                const transformed = response.data.Data.map((item) => ({
                    Id: item.MealTypeId,
                    Name: item.MealTypeName,
                }));
                setMealType(transformed);
            } else {
                setMealType([]);
            }
        } catch (error) {
            toast.error('Error loading meal types');
            setMealType([]);
        }
    };

    const fetchFoodItems = async () => {
        if (!selectedMeal || !selectedYear || !selectedMonth || !selectedDay) {
            return;
        }

        setLoading(true);
        try {
            const response = await axiosInstance.post('MstFood/RetriveTrnFoodWeekCalAll', {
                FoodWeekCalId: 0,
                PropId: globalProperty || 0,
                MealTypeId: selectedMeal,
                FoodWeekCalDt: formatDate(selectedDate),
                DayNm: selectedDay,
                Flag: "R"
            });

            if (response.data.Status === 0 && response.data.Data?.FoodWeekCalList?.length > 0) {
                const menuData = response.data.Data.FoodWeekCalList[0];

                const transformedItems = {
                    [selectedMeal]: {
                        items: menuData.FoodWeekCalList.map(item => ({
                            id: item.FoodId,
                            name: item.FoodName,
                            detailId: item.FoodWeekCalDtlId,
                            foodWeekCalId: item.FoodWeekCalId,
                            CurFoodId: item.CurFoodId
                        }))
                    }
                };

                setFoodItems(transformedItems);
                setHasChanges(false);
                const newCheckedItems = {};
                menuData.FoodWeekCalList.forEach(item => {
                    const key = `${selectedDay}-${selectedMeal}-${item.FoodName}`;
                    newCheckedItems[key] = item.CurFoodId === 1;
                });

                setCheckedItems(newCheckedItems);

                const menuKey = `${selectedDay}-${selectedMeal}`;
                setSavedMenus(prev => ({
                    ...prev,
                    [menuKey]: menuData.FoodWeekCalList
                        .filter(item => item.CurFoodId === 1)
                        .map(item => item.FoodName)
                }));

            } else {
                setFoodItems({});
                setHasChanges(false);
                toast.info('No items found for selected criteria');
            }
        } catch (error) {
            console.error('Error fetching food items:', error);
            toast.error('Error loading food items');
            setFoodItems({});
            setHasChanges(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMealTypesForDropdown();
    }, []);

    useEffect(() => {
        if (selectedMeal && selectedYear && selectedMonth && selectedDay) {
            fetchFoodItems();
            setHasChanges(false);
        }
    }, [selectedMeal, selectedYear, selectedMonth, selectedDay]);

    useEffect(() => {
        if (foodItems[selectedMeal]) {
            const stats = {
                items: {
                    total: foodItems[selectedMeal]?.items?.length || 0,
                    selected: Object.keys(checkedItems).filter(key =>
                        key.startsWith(`${selectedDay}-${selectedMeal}`)
                    ).length
                }
            };
            setCategoryStats(stats);
        }
    }, [selectedMeal, selectedDay, checkedItems, foodItems]);

    const handleDayChange = (event) => {
        setSelectedDay(event.target.value);
    };

    const handleMealChange = (event) => {
        setSelectedMeal(event.target.value);
        setSearchText('');
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const handleCheckboxChange = (foodName) => {
        console.log('Toggling checkbox for:', foodName);
        const key = `${selectedDay}-${selectedMeal}-${foodName}`;
        setHasChanges(true);
        setCheckedItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));

        const item = foodItems[selectedMeal]?.items.find(i => i.name === foodName);

    };

    const handleSearchChange = (event) => {
        setSearchText(event.target.value);
    };

    const clearSearch = () => {
        setSearchText('');
    };

    const getSelectedItems = () => {
        return Object.entries(checkedItems)
            .filter(([key, value]) => value && key.startsWith(`${selectedDay}-${selectedMeal}`))
            .map(([key]) => {
                const parts = key.split('-');
                return parts.slice(2).join('-');
            });
    };

    const handleSave = async () => {
        const selected = getSelectedItems();
        console.log('Saving menu for:', { selectedDay, selectedMeal, selectedYear, selectedMonth, selectedItems: selected });

        if (!selectedMeal || !selectedYear || !selectedMonth || !selectedDay) {
            toast.error('Please select all required fields');
            return;
        }

        if (selected.length === 0) {
            toast.warning('No items selected to save');
            return;
        }

        setLoading(true);

        try {
            const existingMenu = foodItems[selectedMeal]?.items[0]?.foodWeekCalId || 0;
            const monthName = months.find(m => m.value === selectedMonth)?.name || "";
            const mstFoodEntities = foodItems[selectedMeal]?.items.map(item => {
                const itemKey = `${selectedDay}-${selectedMeal}-${item.name}`;
                const isChecked = checkedItems[itemKey] || false;

                return {
                    TrnFoodWeekCalDtlId: 0,
                    TrnFoodWeekCalId: 0,
                    FoodWeekCalDtlId: item.detailId || 1,
                    FoodWeekCalId: existingMenu || 1,
                    FoodId: item.id || 0,
                    ActFoodId: 1,
                    CurFoodId: isChecked ? 1 : 0
                };
            }) || [];
            const payload = {
                TrnFoodWeekCalId: 0,
                FoodWeekCalDt: formatDate(selectedDate),
                FoodWeekCalId: existingMenu || 1,
                PropId: globalProperty || 0,
                MealTypeId: selectedMeal,
                YearId: selectedYear,
                MonthId: selectedMonth,
                MonthNm: monthName,
                DayNm: selectedDay,
                Status: "1",
                UserId: UserId,
                mstFoodEntities: mstFoodEntities
            };

            const response = await axiosInstance.post('MstFood/MangeTrnFoodWeekCal', payload);

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Menu saved successfully');

                await fetchFoodItems();
                setHasChanges(false);
            } else {
                toast.error(response.data.Message || 'Error saving menu');
            }
        } catch (error) {
            console.error('Error saving menu:', error);
            toast.error(error.response?.data?.Message || 'Error saving menu. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    const getAllItems = () => {
        return foodItems[selectedMeal]?.items || [];
    };

    const filteredItems = () => {
        const items = foodItems[selectedMeal]?.items || [];
        return items.filter(item =>
            item.name.toLowerCase().includes(searchText.toLowerCase())
        );
    };

    const selectedItems = getSelectedItems();
    const allItems = getAllItems();
    const filteredItemsList = filteredItems();
    const hasItems = filteredItemsList.length > 0;

    const handleExit = () => {
        navigate('/food-transport');
    }
    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const handleDateChange = (newDate) => {
        if (newDate) {
            setSelectedDate(newDate);
            setSelectedYear(newDate.getFullYear());
            setSelectedDay(newDate.toLocaleDateString('en-US', { weekday: 'long' }));
            const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const dayName = days[newDate.getDay()];
            setSelectedDay(dayName);
        }
    };
    const handleOpen = () => {
        setOpen(true);
    }

    return (
        <Box sx={{
            p: { xs: 1, sm: 2, md: 3 },
            margin: '0 auto',
            background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
            // minHeight: '100vh'
        }}>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover

            />

            <StyledPaper elevation={3} sx={{ mb: 1, overflow: 'hidden', borderRadius: 3 }}>
                <GradientHeader>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                        <RestaurantMenuIcon sx={{ fontSize: 22 }} />
                        <Typography variant="h6" fontWeight="bold" letterSpacing={1}>
                            Day Wise Meal Plan
                        </Typography>
                    </Box>
                </GradientHeader>

                <Box sx={{ p: 2, bgcolor: '#f8fafc' }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={2}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <EventIcon fontSize="small" />
                                            Select Date
                                        </Box>
                                    }
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    format="dd/MM/yyyy"
                                    slotProps={{
                                        textField: {
                                            variant: 'filled',
                                            fullWidth: true,
                                            sx: { borderRadius: 2 },
                                            className: 'custom-textfield'
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Grid>


                        <Grid item xs={12} md={2.5}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <TodayIcon fontSize="small" />
                                        Day
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedDay}
                                    onChange={handleDayChange}
                                    label="Select Day"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                    disabled
                                >
                                    {days.map(day => (
                                        <MenuItem key={day} value={day}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar sx={{ width: 16, height: 16, bgcolor: '#667eea', fontSize: 12 }}>
                                                    {day[0]}
                                                </Avatar>
                                                {day}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={2.5}>
                            <FormControl variant="filled" fullWidth className="custom-select">
                                <InputLabel>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <LocalDiningIcon fontSize="small" />
                                        Meal Type
                                    </Box>
                                </InputLabel>
                                <Select
                                    value={selectedMeal}
                                    onChange={handleMealChange}
                                    label="Select Meal"
                                    sx={{ borderRadius: 2 }}
                                    className="custom-textfield"
                                >
                                    {mealType.map(meal => (
                                        <MenuItem key={meal.Id} value={meal.Id}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Avatar sx={{ width: 16, height: 16, bgcolor: '#764ba2' }}>
                                                    <MealIcon type={meal.Name?.toLowerCase()} />
                                                </Avatar>
                                                {meal.Name}
                                            </Box>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <Stack
                                direction="row"
                                spacing={1}
                                justifyContent={{ xs: 'center', md: 'flex-end' }}
                                flexWrap="wrap"
                                useFlexGap
                            >

                                <Tooltip title={permissions?.EditRec === '0'
                                    ? "You don't have permission to Update items"
                                    : hasChanges ? "Save current selection" : "No changes to save"}>
                                    <span>
                                        <Button
                                            variant="contained"
                                            startIcon={<SaveIcon />}
                                            onClick={handleSave}
                                            disabled={!hasChanges || permissions?.EditRec === '0'}
                                            sx={{
                                                background: hasChanges && permissions?.EditRec
                                                    ? 'linear-gradient(45deg, #10b981, #059669)'
                                                    : 'linear-gradient(45deg, #d1d5db, #9ca3af)',
                                                '&:hover': {
                                                    background: hasChanges && permissions?.EditRec
                                                        ? 'linear-gradient(45deg, #059669, #047857)'
                                                        : 'linear-gradient(45deg, #d1d5db, #9ca3af)',
                                                },
                                                '&.Mui-disabled': {
                                                    background: 'linear-gradient(45deg, #e5e7eb, #d1d5db)',
                                                    color: '#6b7280'
                                                },
                                                borderRadius: 2,
                                                minWidth: 80
                                            }}
                                        >
                                            Update
                                        </Button>
                                    </span>
                                </Tooltip>

                                <Tooltip title={permissions?.AddRec === '0' ? "You don't have permission to Add items" : "Bulk Add"}>
                                    <span>
                                        <Button
                                            variant="contained"
                                            startIcon={<AddIcon />}
                                            onClick={handleOpen}
                                            disabled={permissions?.AddRec === '0'}
                                            sx={{
                                                background: permissions?.AddRec === '0'
                                                    ? 'linear-gradient(45deg, #d1d5db, #9ca3af)'
                                                    : 'linear-gradient(45deg, #59a5f0, #73aef2)',
                                                '&:hover': {
                                                    background: permissions?.AddRec === '0'
                                                        ? 'linear-gradient(45deg, #d1d5db, #9ca3af)'
                                                        : 'linear-gradient(45deg, #739fec, #5bb2fa)',
                                                },
                                                borderRadius: 2,
                                                minWidth: 80
                                            }}
                                        >
                                            Bulk Add
                                        </Button>
                                    </span>
                                </Tooltip>
                                <Tooltip title="Redirect to menu">
                                    <Button
                                        variant="contained"
                                        startIcon={<TravelExploreIcon />}
                                        onClick={() => navigate('/food-menu')}
                                        sx={{
                                            background: 'linear-gradient(45deg, #24e9f3, #73aef2)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #3bf1e5, #5bb2fa)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 80
                                        }}
                                    >
                                        Menu
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Print">
                                    <Button
                                        variant="contained"
                                        startIcon={<PrintIcon />}
                                        onClick={() => setPrintDialogOpen(true)}
                                        sx={{
                                            background: 'linear-gradient(45deg, #6d9d33, #9de546)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #6d9d33, #a8ca38)',
                                            },
                                            minWidth: 80
                                        }}
                                    >
                                        Print
                                    </Button>
                                </Tooltip>
                                <Tooltip title="Exit">
                                    <Button
                                        variant="contained"
                                        startIcon={<ExitToAppIcon />}
                                        onClick={handleExit}
                                        sx={{
                                            background: 'linear-gradient(45deg, #6366f1, #4f46e5)',
                                            '&:hover': {
                                                background: 'linear-gradient(45deg, #4f46e5, #4338ca)',
                                            },
                                            borderRadius: 2,
                                            minWidth: 80
                                        }}
                                    >
                                        Exit
                                    </Button>
                                </Tooltip>
                            </Stack>
                        </Grid>
                    </Grid>
                </Box>
            </StyledPaper>

            {showSuccess && (
                <Alert
                    severity="success"
                    sx={{ mb: 2, borderRadius: 2 }}
                >
                    Menu saved successfully! 🎉
                </Alert>
            )}

            {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

            <Grid container spacing={3}>
                <Grid item xs={12} md={7}>
                    <StyledPaper elevation={2} sx={{ p: 1, height: '100%', borderRadius: 3 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ bgcolor: '#667eea' }}>
                                    <MealIcon type={mealType.find(m => m.Id === selectedMeal)?.Name?.toLowerCase()} />
                                </Avatar>
                                <Typography variant="h6" fontWeight="bold" color="primary">
                                    {mealType.find(m => m.Id === selectedMeal)?.Name} Items
                                </Typography>
                            </Box>
                            <Badge badgeContent={selectedItems.length} color="success" showZero>
                                <Chip
                                    label={`${selectedItems.length}/${allItems.length}`}
                                    size="small"
                                    color="primary"
                                    variant="outlined"
                                />
                            </Badge>
                        </Box>

                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder="Search delicious items..."
                            value={searchText}
                            onChange={handleSearchChange}
                            size="small"
                            sx={{ mb: 2, borderRadius: 2 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon color="action" />
                                    </InputAdornment>
                                ),
                                endAdornment: searchText && (
                                    <InputAdornment position="end">
                                        <IconButton size="small" onClick={clearSearch}>
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />

                        <Box sx={{ maxHeight: 500, overflow: 'auto', pr: 1 }}>
                            {hasItems ? (
                                <Card
                                    sx={{
                                        mb: 1,
                                        borderRadius: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <CardContent sx={{ p: 1, pb: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography variant="subtitle1" fontWeight="bold" sx={{ textTransform: 'capitalize' }}>
                                                Food Items
                                            </Typography>
                                            <Chip
                                                label={`${selectedItems.length}/${allItems.length}`}
                                                size="small"
                                                color={selectedItems.length === allItems.length ? "success" : "default"}
                                            />
                                        </Box>

                                        <LinearProgress
                                            variant="determinate"
                                            value={allItems.length > 0 ? (selectedItems.length / allItems.length) * 100 : 0}
                                            sx={{
                                                mb: 1,
                                                height: 4,
                                                borderRadius: 2,
                                                bgcolor: alpha('#10b981', 0.1),
                                                '& .MuiLinearProgress-bar': {
                                                    bgcolor: '#10b981'
                                                }
                                            }}
                                        />

                                        <FormGroup sx={{ p: 0, m: 0 }}>
                                            <Grid container spacing={0} sx={{ p: 0, m: 0, maxHeight: 400, overflowY: 'auto' }}>
                                                {filteredItemsList.filter(item => item.name !== '').map((item) => {
                                                    const itemKey = `${selectedDay}-${selectedMeal}-${item.name}`;
                                                    return (
                                                        <Grid item xs={12} sm={4} key={item.id || itemKey} sx={{ p: 0, m: 0 }}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={checkedItems[itemKey] || false}
                                                                        onChange={() => handleCheckboxChange(item.name)}
                                                                        sx={{
                                                                            p: 0,
                                                                            color: '#10b981',
                                                                            '&.Mui-checked': {
                                                                                color: '#10b981',
                                                                            },
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            m: 0,
                                                                            fontWeight: checkedItems[itemKey] ? 600 : 500,
                                                                            color: checkedItems[itemKey] ? '#10b981' : 'inherit',
                                                                        }}
                                                                    >
                                                                        {item.name}
                                                                    </Typography>
                                                                }
                                                                sx={{
                                                                    width: '100%',
                                                                    m: 0,
                                                                    p: 0,
                                                                    borderRadius: 0,
                                                                    '&:hover': {
                                                                        bgcolor: alpha('#667eea', 0.1),
                                                                    },
                                                                    bgcolor: checkedItems[itemKey]
                                                                        ? alpha('#10b981', 0.05)
                                                                        : 'transparent',
                                                                }}
                                                            />
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        </FormGroup>
                                    </CardContent>
                                </Card>
                            ) : (
                                <Box sx={{ textAlign: 'center', py: 8 }}>
                                    <SearchIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
                                    <Typography color="text.secondary">
                                        {selectedMeal ? 'No items found matching "' + searchText + '"' : 'Please select meal type'}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </StyledPaper>
                </Grid>

                <Grid item xs={12} md={5}>
                    <StyledPaper
                        elevation={2}
                        sx={{
                            p: 2,
                            height: '100%',
                            borderRadius: 3,
                            background: 'linear-gradient(135deg, #f0f9ff 0%, #e6f0fa 100%)'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <Avatar sx={{ bgcolor: '#10b981' }}>
                                <CheckCircleIcon />
                            </Avatar>
                            <Typography variant="h6" fontWeight="bold" color="#2563eb">
                                Selected Items
                            </Typography>
                        </Box>

                        <Divider />

                        <Box sx={{ minHeight: 400 }}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 2,
                                    mb: 1,
                                    bgcolor: 'white',
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: '#2563eb'
                                }}
                            >
                                <Typography variant="subtitle1" fontWeight="bold" color="#2563eb" gutterBottom>
                                    {selectedDay} - {months.find(m => m.value === selectedMonth)?.name} {selectedYear}
                                </Typography>
                                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                    {mealType.find(m => m.Id === selectedMeal)?.Name}
                                </Typography>

                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => (
                                            <Chip
                                                key={index}
                                                label={item}
                                                onDelete={() => {
                                                    const itemKey = `${selectedDay}-${selectedMeal}-${item}`;
                                                    setCheckedItems(prev => {
                                                        const newState = { ...prev };
                                                        delete newState[itemKey];
                                                         setHasChanges(true);
                                                        return newState;
                                                       
                                                    });
                                                }}
                                                sx={{
                                                    bgcolor: 'white',
                                                    border: '1px solid #2563eb',
                                                    height: 27,
                                                    fontWeight: 500,
                                                    '& .MuiChip-deleteIcon': {
                                                        color: '#ef4444',
                                                        '&:hover': { color: '#dc2626' }
                                                    },
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <Box sx={{
                                            py: 6,
                                            width: '100%',
                                            textAlign: 'center',
                                            bgcolor: alpha('#2563eb', 0.02),
                                            borderRadius: 2
                                        }}>
                                            <RestaurantMenuIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} />
                                            <Typography color="text.secondary">
                                                No items selected yet
                                            </Typography>
                                            <Typography variant="caption" color="text.secondary">
                                                Check some items from the list
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Paper>

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Card sx={{ bgcolor: alpha('#10b981', 0.1), borderRadius: 2 }}>
                                        <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                            <Typography variant="h4" color="#10b981" fontWeight="bold">
                                                {selectedItems.length}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Selected Items
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={6}>
                                    <Card sx={{ bgcolor: alpha('#667eea', 0.1), borderRadius: 2 }}>
                                        <CardContent sx={{ textAlign: 'center', py: 2 }}>
                                            <Typography variant="h4" color="#667eea" fontWeight="bold">
                                                {allItems.length}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Total Available
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            <Box sx={{ mt: 2 }}>
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    Selection Progress
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={allItems.length > 0 ? (selectedItems.length / allItems.length) * 100 : 0}
                                    sx={{
                                        height: 8,
                                        borderRadius: 4,
                                        bgcolor: alpha('#10b981', 0.1),
                                        '& .MuiLinearProgress-bar': {
                                            background: 'linear-gradient(90deg, #10b981, #059669)'
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </StyledPaper>
                </Grid>
            </Grid>
            <Datepopup
                open={open}
                setOpen={setOpen}
                selectedDate={selectedDate}
                selectedMeal={selectedMeal}
                selectedDay={selectedDay}
                globalProperty={globalProperty}
            />
            <PrintDialog
                open={printDialogOpen}
                onClose={() => setPrintDialogOpen(false)}
                // selectedMeal={selectedMeal}
                globalProperty={globalProperty}
            />
        </Box>
    );
};

export default DaywiseFood;